export const courses = [
  {
    id: "fullstack-web-development",
    category: "fullstack",
    title: "Full Stack Web Development",
    duration: "6 Months",
    icon: "laptop",

    tools: ["HTML", "CSS", "JS", "React", "Node", "MongoDB"],

    whoCanJoin: "Beginners, Aspiring Web Developers",

    build: "Dynamic web applications like e-commerce platforms and dashboards.",

    syllabus: [
      {
        title: "HTML & CSS",
        topics: [
          "HTML5 structure & semantic tags",
          "Forms, tables, media",
          "CSS fundamentals",
          "Box model & positioning",
          "Flexbox & Grid",
          "Responsive design",
          "Basic UI/UX practices"
        
        ],
      },
      {
        title: "JavaScript & React",
        topics: [
          "JavaScript basics",
          "Variables & data types",
          "Operators & conditions",
          "Loops",
          "Functions & scope",
          "Arrays & objects",
          "DOM manipulation",
          "Events",
        ],
      },
       {
        title: "Advanced JavaScript & Git",
        topics: [
          "ES6+ features",
          "Arrow functions",
          "Destructuring",
          "Promises",
          "Async / Await",
          "Error handling",
          "Git & GitHub",
          "Version control workflow"
        ],
      },
      {
        title: "React.js – Frontend Development",
        topics: [
          "React fundamentals",
          "Components & JSX",
          "Props & State",
          "Hooks (useState, useEffect, useContext)",
          "React Router",
          "API integration",
          "Basic performance optimization"
        ],
      },   
      {
        title: "Backend Development – Node.js & Express.js",
        topics: [
          "Node.js fundamentals",
          "Express.js framework",
          "REST API creation",
          "Middleware",
          "Authentication & authorization",
          "Error handling"
        ],
      },
      {
        title: "Databases – MySQL & MongoDB",
        topics: [
          "Database fundamentals",
          "MySQL CRUD operations",
          "MongoDB collections & documents",
          "Connecting databases with backend"
        ],
      },
      {
        title: "Full Stack Integration & Deployment",
        topics: [
          "Frontend + Backend integration",
          "Authentication flow",
          "Environment variables",
          "Basic deployment concepts"
        ],
      },
       {
        title: "Final Capstone Project (Ongoing + Final Month)",
        topics: [
          "Online Course Platform",
          "Student Management System",
          "Inventory / Billing System",
          "Blog or E-commerce Website"
        ],
      },
    ],
  },

  {
    id: "Java-Full-Stack-Web-Development-Program",
    category: "fullstack",
    title: "Java Full Stack Web Development Program",
    duration: "6 Months",
    icon: "JAVA",

    tools: ["HTML", "CSS", "JS", "JAVA", "MYSQL", "GIT"],

    whoCanJoin: "Beginners",

    build: "Build real-world full stack applications.",

    syllabus: [
       {
        title: "Web Fundamentals – HTML & CSS",
        topics: [
          "HTML5 & semantic tags",
          "Forms, tables, media",
          "CSS fundamentals",
          "Box model & positioning",
          "Flexbox & Grid",
          "Responsive design"
         ],
      },
       {
        title: "JavaScript Fundamentals",
        topics: [
          "JavaScript basics",
          "Data types & operators",
          "Conditions & loops",
          "Functions & scope",
          "Arrays & objects",
          "DOM manipulation",
          "Events"
         ],
      },
        {
        title: "Core Java Programming",
        topics: [
          "Java basics & syntax",
          "OOP concepts",
          "Constructors & methods",
          "Inheritance & polymorphism",
          "Exception handling",
          "Collections framework",
          "Multithreading basics"
         ],
      },
       {
        title: "JDBC & Database (MySQL)",
        topics: [
          "JJDBC architecture",
          "Database fundamentals",
          "Connecting Java with MySQL",
          "CRUD operations",
          "SQL queries",
          "Joins & constraints"
         ],
      },
       {
        title: "Spring Boot & REST API",
        topics: [
          "Spring Boot fundamentals",
          "MVC architecture",
          "RESTful services",
          "CRUD APIs",
          "Validation",
          "Exception handling",
          "Basic security concepts"
         ],
      },
       {
        title: "Full Stack Integration & Deployment",
        topics: [
          "Frontend + Backend integration",
          "REST API consumption",
          "Authentication flow",
          "Environment variables",
          "Basic deployment concepts"
         ],
      },
      {
        title: "Final Capstone Project (Ongoing)",
        topics: [
          "Student Management System",
          "Online Course Platform",
          "Inventory / Billing System",
          "Employee Management Portal"
         ],
      },
    ],
  },
    
  {
    id: "Python-Full-Stack-Web-Development-Program",
    category: "fullstack",
    title: "Python Full Stack Web Development Program",
    duration: "6 Months",
    icon: "PYTHON",
    tools: ["HTML", "CSS", "JS", "PYTHON", "MYSQL", "GIT"],

    whoCanJoin: "Beginners",

    build: "Build real-world full stack applications.",

    syllabus: [
       {
        title: "Web Fundamentals – HTML & CSS",
        topics: [
          "HTML5 & semantic tags",
          "Forms, tables, media",
          "CSS fundamentals",
          "Box model & positioning",
          "Flexbox & Grid",
          "Responsive design"
         ],
      },
       {
        title: "JavaScript Fundamentals",
        topics: [
          "JavaScript basics",
          "Data types & operators",
          "Conditions & loops",
          "Functions & scope",
          "Arrays & objects",
          "DOM manipulation",
          "Events"
         ],
      },
        {
        title: "Core Python Programming",
        topics: [
          "Python basics & syntax",
          "Variables & data types",
          "Control statements",
          "Functions & modules",
          "Lists, tuples, sets, dictionaries",
          "File handling",
          "Exception handling",
          "OOP concepts in Python"
         ],
      },
       {
        title: "Database & ORM (MySQL)",
        topics: [
          "Database fundamentals",
          "MySQL CRUD operations",
          "SQL queries",
          "Joins & constraints",
          "Django ORM basics"
         ],
      },
       {
        title: "Django Framework & REST API",
        topics: [
          "Django architecture (MTV)",
          "Models, views & templates",
          "Forms & validations",
          "Authentication & authorization",
          "REST API with Django REST Framework",
          "CRUD operations",
          "Exception handling"
         ],
      },
       {
        title: "Full Stack Integration & Deployment",
        topics: [
          "Frontend + Backend integration",
          "REST API consumption",
          "Authentication flow",
          "Environment variables",
          "Basic deployment concepts"
         ],
      },
      {
        title: "Final Capstone Project (Ongoing)",
        topics: [
          "Student Management System",
          "Online Course Platform",
          "Inventory / Billing System",
          "Employee Management Portal"
         ],
      },
    ],
  },

  {
    id: "Frontend-Development",
    category: "fullstack",
    title: "Frontend Development",
    duration: "3 Months",
    icon: "frontend",
    tools: ["HTML", "CSS", "JS",  "GIT"],

    whoCanJoin: "Beginners",

    build: "Build real-world full stack applications.",

    syllabus: [
       {
        title: "Web Basics & HTML",
        topics: [
          "How the web works",
          "HTML structure & tags",
          "Forms & inputs",
          "Tables & media",
          "Semantic HTML"
         ],
      },
       {
        title: "CSS & Responsive Design",
        topics: [
          "CSS selectors & properties",
          "Box model",
          "Flexbox & Grid",
          "Responsive design",
          "Media queries",
          "Basic animations"
         ],
      },
        {
        title: "JavaScript Fundamentals",
        topics: [
          "Variables & data types",
          "Conditions & loops",
          "Functions",
          "Arrays & objects",
          "DOM manipulation",
          "Events"
         ],
      },
       {
        title: "Advanced JavaScript",
        topics: [
          "ES6 features",
          "Arrow functions",
          "Promises & async/await",
          "API integration (Fetch)",
          "Local storage"
         ],
      },
       {
        title: "React OR Angular Framework",
        topics: [
          "Components & JSX",
          "Props & State",
          "Hooks",
          "Routing",
          "API integration"
         ],
      },
       {
        title: "Project & Deployment",
        topics: [
          "Git & GitHub",
          "Hosting (Netlify / Vercel)",
          "Performance basics",
          "Resume & portfolio guidance"
         ],
      },
    ],
  },

  {
    id: "Backend-Development",
    category: "fullstack",
    title: "Backend Development",
    duration: "3 Months",
    icon: "backend",
    tools: ["Python", "Django", "MySQL", "GIT"],

    whoCanJoin: "Beginners",

    build: "Build real-world full stack applications.",

    syllabus: [
       {
        title: "Backend Fundamentals & Web Basics",
        topics: [
          "Client–Server architecture",
          "HTTP & HTTPS",
          "RESTful APIs",
          "Request & Response cycle",
          "JSON"
         ],
      },
       {
        title: "Node.js Fundamentals",
        topics: [
          "Node.js architecture",
          "npm & package.json",
          "Modules",
          "File system",
          "Event loop"
         ],
      },
        {
        title: "Express.js Framework",
        topics: [
          "Express setup",
          "Routing",
          "Middleware",
          "Controllers & services",
          "Error handling"
         ],
      },
       {
        title: "Database – SQL & NoSQL",
        topics: [
          "Database concepts",
          "MySQL (tables, joins, queries)",
          "MongoDB (CRUD, schema design)",
          "Mongoose ORM"
         ],
      },
       {
        title: "Authentication & Security",
        topics: [
          "Authentication vs Authorization",
          "JWT",
          "Password hashing (bcrypt)",
          "Role-based access",
          "Environment variables"
         ],
      },
       {
        title: "Advanced Backend Concepts",
        topics: [
          "API pagination & filtering",
          "File uploads", 
      "Email service",
"Payment gateway (intro)",
"Performance optimization",
          
],
      },
             {
        title: "Testing, Deployment & DevOps Basics",
        topics: [
          "API testing",
"Logging",
"Deployment",
"Server basics",
"CI/CD intro",
          
],
      },
    ],
  },

//Data science and AI courses will be added here in the future

  {
    id: "Data Analytics program",
    category: "datascience",
    title: "Data Analytics program",
    duration: "6 Months",
    icon: "datascience",
    tools: ["Python", "MySQL", "PowerBI", "MS Excel"],
    whoCanJoin: "Beginners",

    build: "Build dashboards, reports, and real-world data analysis projects.",

    syllabus: [
       {
        title: "Data Fundamentals & Excel",
        topics: [
          "Introduction to Data Analytics",
          "Types of data",
          "Excel basics & shortcuts",
          "Data cleaning & formatting",
          "Formulas & functions",
          "Pivot tables & charts"
         ],
      },
       {
        title: "Statistics for Data Analysis",
        topics: [
          "Descriptive statistics",
          "Mean, median, mode",
          "Variance & standard deviation",
          "Probability basics",
          "Correlation & regression",
          "Hypothesis testing (intro)"
         ],
      },
        {
        title: "SQL for Data Analysis",
        topics: [
          "Database concepts",
          "SQL queries (SELECT, WHERE, JOIN)",
          "Group By & Aggregate functions",
          "Subqueries",
          "Views & indexing"
         ],
      },
       {
        title: "Python for Data Analysis",
        topics: [
          "Python basics",
          "NumPy",
          "Pandas",
          "Data cleaning & manipulation",
          "Data visualization (Matplotlib, Seaborn)"
         ],
      },
       {
        title: "Power BI & Data Visualization",
        topics: [
          "Power BI interface",
          "Data modeling",
          "DAX basics",
          "Interactive dashboards",
          "Reports & storytelling"
         ],
      },
       {
        title: "Real-World Analytics & Capstone",
        topics: [
          "End-to-end data analysis workflow",
          "Business problem solving",
          "KPI analysis",
          "Data presentation techniques",
          "Resume & interview preparation"
         ],
      },
    ],
  },

  {
    id: "Data Science Program",
    category: "datascience",
    title: "Data Science Program",
    duration: "6 Months",
    icon: "datascience",
    tools: ["Python", "MySQL", "PowerBI", "MS Excel"],
    whoCanJoin: "Beginners",

    build: "Build dashboards, reports, and real-world data analysis projects.",

    syllabus: [
       {
        title: "Python Programming for Data Science",
        topics: [
          "Python basics & syntax",
          "Variables & data types",
          "Control statements",
          "Functions & modules",
          "Data structures (list, tuple, set, dict)",
          "File handling",
          "OOP basics"
         ],
      },
       {
        title: "Statistics & Mathematics for Data Science",
        topics: [
          "Descriptive statistics",
          "Mean, median, mode",
          "Variance & standard deviation",
          "Probability basics",
          "Correlation & regression",
          "Hypothesis testing (intro)"
         ],
      },
        {
        title: "SQL for Data Analysis",
        topics: [
          "Database concepts",
          "SQL queries (SELECT, WHERE, JOIN)",
          "Group By & Aggregate functions",
          "Subqueries",
          "Views & indexing"
         ],
      },
       {
        title: "Machine Learning",
        topics: [
          "Machine Learning concepts",
          "Supervised learning",
          "Regression algorithms",
          "Classification algorithms",
          "Model evaluation",
          "Feature engineering",
          "Introduction to Scikit-learn"

         ],
      },
       {
        title: "Advanced Topics & Capstone",
        topics: [
          "Unsupervised learning",
          "Clustering (K-Means)",
          "Dimensionality reduction",
          "Introduction to Deep Learning",
          "Model deployment basics",
          "Resume & interview preparation"
         ],
      },
    ],
  },

  {
    id: "Machine Learning with Python",
    category: "datascience",
    title: "Machine Learning with Python",
    duration: "6 Months",
    icon: "datascience",
    tools: ["Python"],
    whoCanJoin: "Beginners",

    build: "Build dashboards, reports, and real-world data analysis projects.",

    syllabus: [
       {
        title: "Python Foundations for Machine Learning",
        topics: [
          "Python basics & syntax",
          "Variables & data types",
          "Control statements",
          "Functions & modules",
          "Data structures",
          "File handling",
          "OOP basics"
         ],
      },
       {
        title: "Mathematics & Statistics for ML",
        topics: [
          "Descriptive statistics",
          "Probability basics",
          "Mean, median, variance",
          "Correlation & covariance",
          "Linear algebra fundamentals",
          "Gradient intuition"
         ],
      },
        {
        title: "Data Analysis & Visualization",
        topics: [
          "NumPy arrays & operations",
          "Pandas dataframes",
          "Data cleaning & preprocessing",
          "Handling missing values",
          "Data visualization",
          "Exploratory Data Analysis (EDA)"
         ],
      },
       {
        title: "Supervised Machine Learning",
        topics: [
          "Machine learning workflow",
          "Linear regression",
          "Logistic regression",
          "K-Nearest Neighbors (KNN)",
          "Decision Trees",
          "Random Forest",
          "Model evaluation metrics"

         ],
      },
       {
        title: "Unsupervised Machine Learning",
        topics: [
          "Clustering concepts",
          "K-Means clustering",
          "Hierarchical clustering",
          "Dimensionality reduction (PCA)",
          "Anomaly detection basics"
         ],
      },
             {
        title: "Model Optimization & Deployment Basics",
        topics: [
          "Feature engineering",
          "Hyperparameter tuning",
          "Cross-validation",
          "Model saving & loading",
          "Introduction to deployment",
          "ML project best practices"
         ],
      },
    ],
  },

  {
    id: "Artificial Intelligence & Machine Learning Program",
    category: "datascience",
    title: "Artificial Intelligence & Machine Learning Program",
    duration: "6 Months",
    icon: "datascience",
    tools: ["Python"],
    whoCanJoin: "Beginners",

    build: "Build dashboards, reports, and real-world data analysis projects.",

    syllabus: [
       {
        title: "Python Foundations for AI & ML",
        topics: [
          "Python basics & syntax",
          "Variables & data types",
          "Control statements",
          "Functions & modules",
          "Data structures",
          "File handling",
          "OOP basics"
         ],
      },
       {
        title: "Mathematics & Statistics for AI & ML",
        topics: [
          "Descriptive statistics",
          "Probability basics",
          "Mean, median, variance",
          "Correlation & covariance",
          "Linear algebra fundamentals",
          "Gradient intuition"
         ],
      },
        {
        title: "Data Analysis & Visualization",
        topics: [
          "NumPy arrays & operations",
          "Pandas dataframes",
          "Data cleaning & preprocessing",
          "Handling missing values",
          "Data visualization",
          "Exploratory Data Analysis (EDA)"
         ],
      },
       {
        title: "Supervised Machine Learning",
        topics: [
          "Machine learning workflow",
          "Linear regression",
          "Logistic regression",
          "K-Nearest Neighbors (KNN)",
          "Decision Trees",
          "Random Forest",
          "Model evaluation metrics"

         ],
      },
       {
        title: "Unsupervised Machine Learning",
        topics: [
          "Clustering concepts",
          "K-Means clustering",
          "Hierarchical clustering",
          "Dimensionality reduction (PCA)",
          "Anomaly detection basics"
         ],
      },
             {
        title: "Model Optimization & Deployment Basics",
        topics: [
          "Feature engineering",
          "Hyperparameter tuning",
          "Cross-validation",
          "Model saving & loading",
          "Introduction to deployment",
          "ML project best practices"
         ],
      },
                   {
        title: "AI Applications & Capstone Project",
        topics: [
          "Natural Language Processing (NLP) basics",
          "Chatbot fundamentals",
          "Recommendation systems",
          "Model deployment basics",
          "AI ethics & best practices"
         ],
      },
    ],
  },


  //MS office 
  {
    id: "MS-Office",
    category: "Officeandbusiness",
    title: "MS-Office",
    duration: "30 Days",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["Notepad" , "MS Paint" ,  "MS Excel", "MS Powerpoint", "Internet", "Chatgpt"],

    build: "Outcome: Office productivity + job readiness",

    syllabus: [
       {
        title: "Computer Fundamentals & MS Office Basics",
        topics: [
          "Computer basics",
          "Operating systems",
          "File management",
          "MS Word basics",
          "MS Excel basics",
          "MS PowerPoint basics"
         ],
      },
       {
        title: "MS WORD",
        topics: [
          " MS Word interface & shortcuts",
          "Text formatting & styles",
          "Page setup, headers & footers",
          "Tables, images, shapes",
          "Mail Merge"
         ],
      },
        {
        title: "MS EXCEL",
        topics: [
          "Excel basics",
          "Formulas & functions (SUM, IF, VLOOKUP)",
          "Charts & graphs",
          "Sorting, filtering & Pivot Tables"
         ],
      },
       {
        title: "MS POWERPOINT",
        topics: [
          "Slide layouts & themes",
          "Animations & transitions",
          "Presentation techniques"

         ],
      },
       {
        title: "Email & CHATGPT Basics",
        topics: [
          "Email composing",
          "Attachments & signatures",
          "Calendar scheduling"
         ],
      },
    ],
  },

  {
    id: "Masters in Accountancy with Tally Prime",
    category: "Officeandbusiness",
    title: "Masters in Accountancy with Tally Prime",
    duration: "30 Days",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "Outcome: Office productivity + job readiness",
    tools:["Notepad",  "MS Excel", "Tally Prime", "Internet", "Chatgpt"],
    syllabus: [
       {
        title: "Accounting Fundamentals",
        topics: [
          "Basics of Accounting",
          "Golden rules of accounting",
          "Journal entries & ledger",
          "Mini Project: Journal & ledger for small business"
         ],
      },
       {
        title: "Introduction to Tally Prime",
        topics: [
          "Company creation",
          "Ledger & voucher entries",
          "Mini Project: Company setup with transactions"
         ],
      },
        {
        title: "Practical Accounting in Tally",
        topics: [
          "Purchase & sales",
          "Trial balance",
          "P&L and Balance Sheet",
          "Mini Project: Complete trading business accounts"
         ],
      },
       {
        title: "GST with Tally Prime",
        topics: [
          'GST basics',
          'GST entries & returns',
          'Mini Project: GST billing & reports'
         ],
      },
       {
        title: "Payroll & Inventory",
        topics: [
          "Payroll processing",
          "Inventory management",
          "Mini Project: Salary sheet & stock report"
         ],
      },
    ],
  },

  {
    id: "Business Analytics",
    category: "Officeandbusiness",
    title: "Masters in Accountancy with Tally Prime",
    duration: "30 Days",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["Notepad",  "MS Excel", "PowerBI", "Internet", "Chatgpt"],
    build: "Outcome: Office productivity + job readiness",

    syllabus: [
       {
        title: "Business Analytics Fundamentals",
        topics: [
          "What is Business Analytics",
          "Types: Descriptive, Diagnostic, Predictive",
          "Business decision-making",
          "Data lifecycle",
          "KPIs & metrics"
         ],
      },
       {
        title: "Advanced Excel for Analytics",
        topics: [
          "Excel basics & data formatting",
          "Functions (IF, VLOOKUP, XLOOKUP, INDEX-MATCH)",
          "Pivot tables & charts",
          "Data cleaning",
          "Conditional formatting",
          "What-if analysis",
          "Dashboards"
         ],
      },
        {
        title: "SQL for Data Analysis",
        topics: [
          "Database concepts",
          "SQL queries (SELECT, WHERE, JOIN)",
          "Grouping & aggregation",
          "Subqueries",
          "Views & indexes"
         ],
      },
        {
        title: "Power BI",
        topics: [
          "Power BI interface",
          "Data modeling",
          "DAX basics",
          "Visualizations",
          "Reports & dashboards",
          "Publishing & sharing"
         ],
      },
       {
        title: "Capstone Project & Case Studies",
        topics: [
          "Real-world business case studies",
          "End-to-end data analysis",
          "Presentation & storytelling"
         ],
      },
    ],
  },

  {
    id: "Advanced Excel & Power BI",
    category: "Officeandbusiness",
    title: "Advanced Excel & Power BI",
    duration: "30 Days",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "Outcome: Office productivity + job readiness",
    tools:["Notepad" , "MS Paint" ,  "MS Excel", "MS Powerpoint", "Tally Prime", "Internet", "Chatgpt"],
    syllabus: [
       {
        title: "Excel Foundations & Data Handling",
        topics: [
          "Data types & formatting",
          "Data cleaning techniques",
          "Sorting & filtering",
          "Text functions",
          "Date & time functions"
         ],
      },
       {
        title: "Advanced Excel Functions",
        topics: [
          "Lookup functions (VLOOKUP, XLOOKUP, INDEX-MATCH)",
          "Logical functions (IF, IFS)",
          "Statistical & financial functions",
          "Error handling"
         ],
      },
        {
        title: "Pivot Tables & Dashboards",
        topics: [
          "Pivot tables & pivot charts",
          "Slicers & timelines",
          "Interactive dashboards",
          "What-if analysis"
         ],
      },
        {
        title: "Power BI Fundamentals",
        topics: [
          "Power BI interface",
          "Data import & transformation",
          "Relationships & modeling",
          "Visualizations"
         ],
      },
       {
        title: "Power BI Advanced & Publishing",
        topics: [
          "DAX basics",
          "Calculated columns & measures",
          "Advanced visuals",
          "Publishing & sharing reports"
         ],
      },
    ],
  },

//DESIGNING COURSES WILL BE ADDED HERE IN THE FUTURE
  {
    id: "UI/UX Design Program",
    category: "design",
    title: "UI/UX Design Program",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "Outcome: UI/UX design skills + job readiness",

    syllabus: [
       {
        title: "Introduction to UI/UX & Design Fundamentals",
        topics: [
          "What is UI vs UX",
          "Design thinking process",
          "User-centered design",
          "Color theory",
          "Typography",
          "Layout & visual hierarchy",
          "Accessibility basics"
         ],
      },
       {
        title: "UX Research & User Analysis",
        topics: [
          "User research methods",
          "User personas",
          "User journey mapping",
          "Problem statements",
          "Information architecture",
          "UX documentation"
         ],
      },
        {
        title: "Wireframing & Prototyping",
        topics: [
          "Low-fidelity wireframes",
          "High-fidelity wireframes",
          "Mobile & web layouts",
          "Interactive prototyping",
          "Micro-interactions"
         ],
      },
        {
        title: "UI Design & Design Systems",
        topics: [
          "UI components & patterns",
          "Design systems",
          "Buttons, forms & navigation",
          "Responsive design",
          "UI for web & mobile apps"
         ],
      },
       {
        title: "Usability Testing & UX Optimization",
        topics: [
          "Usability testing methods",
          "A/B testing basics",
          "UX metrics",
          "Heuristic evaluation",
          "UX improvements & iteration"
         ],
      },
             {
        title: "Portfolio Building & Capstone Project",
        topics: [
          "UX case study writing",
          "Portfolio creation",
          "Design presentation skills",
          "Resume & interview preparation",
          "Freelancing & career guidance"
         ],
      },
    ],
  },

  {
    id: "Graphic Design",
    category: "design",
    title: "Graphic Design",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "Outcome: UI/UX design skills + job readiness",

    syllabus: [
       {
        title: "Design Fundamentals",
        topics: [
          "What is Graphic Design",
          "Design principles (color, typography, layout)",
          "Branding basics",
          "Understanding design briefs"
         ],
      },
       {
        title: "Canva for Graphic Design",
        topics: [
          "Canva interface & tools",
          "Social media creatives",
          "Posters, flyers & banners",
          "Business cards & brochures",
          "Presentations",
          "Brand kits"
         ],
      },
        {
        title: "Photoshop Basics",
        topics: [
          "Photoshop workspace",
          "Layers & masks",
          "Selection tools",
          "Image retouching",
          "Text effects"
         ],
      },
        {
        title: "Advanced Photoshop",
        topics: [
          "Advanced masking",
          "Photo manipulation",
          "Mockups",
          "Digital ads",
          "Exporting for web & print"
         ],
      },
       {
        title: "Portfolio & Freelancing Basics",
        topics: [
          "Design portfolio creation",
          "Client communication",
          "Freelancing platforms intro",
          "Pricing & proposals"
         ],
      },

    ],
  },

  {
    id: "Web Design",
    category: "design",
    title: "Web Design",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "Outcome: UI/UX design skills + job readiness",

    syllabus: [
       {
        title: "Web & UI Design Fundamentals",
        topics: [
          "How websites work",
          "UI vs UX",
          "Design principles",
          "Color theory",
          "Typography basics",
          "Layout concepts"
         ],
      },
       {
        title: "UI Design Tools & Prototyping",
        topics: [
          "Figma interface",
          "Wireframes & mockups",
          "Buttons, cards & components",
          "Mobile & desktop layouts",
          "Design systems"
         ],
      },
        {
        title: "HTML Fundamentals",
        topics: [
          "HTML structure",
          "Forms & inputs",
          "Semantic HTML",
          "Media embedding"
         ],
      },
        {
        title: "CSS Basics & Layouts",
        topics: [
          "CSS selectors",
          "Box model",
          "Flexbox",
          "Grid",
          "Responsive design"
         ],
      },
       {
        title: "Basic JavaScript for UI",
        topics: [
          "JavaScript basics",
          "DOM manipulation",
          "Events",
          "Form validation"
         ],
      },
       {
        title: "Website Deployment & Portfolio",
        topics: [
          "Website optimization",
          "Hosting basics",
          "Git & GitHub",
          "Portfolio building"      
         ],
      },
    ],
  },

  //CORE PROGRAMMING COURSES WILL BE ADDED HERE IN THE FUTURE
  {
    id: "C,-C++-&-Python-Programming",
    category: "CPC",
    title: "C, C++ & Python Programming Course",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["CodeBlock", "Idle"],
    build: "Programming Foundations: C, C++ & Python",

    syllabus: [
       {
        title: "Programming Fundamentals (C)",
        topics: [
          "Programming basics",
          "Algorithms & flowcharts",
          "Data types & variables",
          "Input / Output",
          "Mini Project: Basic calculator"
         ],
      },
       {
        title: "Control Structures & Arrays (C)",
        topics: [
          "if-else, switch",
          "Loops",
          "1D & 2D arrays",
          "Mini Project: Student marks management system"
         ],
      },
        {
        title: "Functions, Pointers & File Handling (C)",
        topics: [
          "Functions",
          "Pointers",
          "File Handling",
          "Mini Project: File-based student management system"
         ],
      },
        {
        title: "C++ Basics & OOP",
        topics: [
          "C++ syntax",
          "Classes & objects",
          "Inheritance",
          "Polymorphism",
         ],
      },
       {
        title: "Advanced C++ Concepts",
        topics: [
          "Inheritance & polymorphism",
          "STL basics",
          "Exception handling",
          "Mini Project: Library or banking system"
         ],
      },
       {
        title: "Python Basics",
        topics: [
          "Syntax",
          "Variables & data types",
          "Input / Output",
          "Mini Project: Calculator"
         ],
      },
      {
        title: "Control Flow & Functions in Python",
        topics: [
          "if-else",
          "Loops",
          "Functions",
          "Mini Project: Number operations"
         ],
      },
 {
        title: "Data Structures & OOP in Python",
        topics: [
          "List, tuple, set, dictionary",
          "Mini Project: Contact management system"
         ],
      },
       {
        title: "OOP & File Handling in Python",
        topics: [
          "Classes & objects",
          "File handling",
          "Exception handling",
          "Mini Project: Student record system"
         ],
      },
   {
        title: "Libraries & Final Project",
        topics: [
          "Modules",
          "Intro to NumPy & Pandas",
          "Mini Project: Automation or data mini project"
         ],
      },
    ],
  },

  {
    id: "C,-C++-&-JAVA-Programming",
    category: "CPC",
    title: "C, C++ & JAVA Programming Course",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["CodeBlock", "Eclipse"],
    build: "Programming Foundations: C, C++ & Java",

    syllabus: [
       {
        title: "Programming Fundamentals (C)",
        topics: [
          "Programming basics",
          "Algorithms & flowcharts",
          "Data types & variables",
          "Input / Output",
          "Mini Project: Basic calculator"
         ],
      },
       {
        title: "Control Structures & Arrays (C)",
        topics: [
          "if-else, switch",
          "Loops",
          "1D & 2D arrays",
          "Mini Project: Student marks management system"
         ],
      },
        {
        title: "Functions, Pointers & File Handling (C)",
        topics: [
          "Functions",
          "Pointers",
          "File Handling",
          "Mini Project: File-based student management system"
         ],
      },
        {
        title: "C++ Basics & OOP",
        topics: [
          "C++ syntax",
          "Classes & objects",
          "Inheritance",
          "Polymorphism",
         ],
      },
       {
        title: "Advanced C++ Concepts",
        topics: [
          "Inheritance & polymorphism",
          "STL basics",
          "Exception handling",
          "Mini Project: Library or banking system"
         ],
      },
       {
        title: "Java Basics & Environment",
        topics: [
          "Java overview",
          "JVM, JRE, JDK",
          "Data types & variables",
          "Input / Output"
         ],
      },
      {
        title: "Control Statements & Arrays",
        topics: [
          "if-else",
          "Loops",
          "Functions",
          "Mini Project: Number operations"
         ],
      },
 {
        title: "OOP Concepts in Java",
        topics: [
          "Classes & objects",
          "Constructors",
          "Encapsulation",
          "Inheritance"
         ],
      },
       {
        title: "Polymorphism & Exception Handling",
        topics: [
          "Method overloading & overriding",
          "Exception handling",
          "Packages"
         ],
      },
   {
        title: "File Handling & Collections",
        topics: [
          "File input/output",
          "Collections framework (List, Set, Map)"
         ],
      },
    ],
  },

  {
    id: "Python-Programming",
    category: "CPC",
    title: "Python Programming (Beginner Level)",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["CodeBlock", "Idle"],
    build: "Programming Foundations: C, C++ & Python",

    syllabus: [
       {
        title: "Python Basics & Syntax",
        topics: [
          "Introduction to Python",
          "Installing Python & IDE",
          "Variables & data types",
          "Operators",
          "Input / Output"
         ],
      },
       {
        title: "Control Statements & Functions",
        topics: [
          "Conditional statements (if, else, elif)",
          "Loops (for, while)",
          "Loop control (break, continue)",
          "Functions",
          "Built-in functions"
         ],
      },
        {
        title: "Python Data Structures",
        topics: [
          "List",
          "Tuple",
          "Set",
          "Dictionary"
         ],
      },
        {
        title: "File Handling, Errors & Mini Projects",
        topics: [
          "File handling (read, write, append)",
          "Exception handling",
          "Basic modules",
          "Python coding best practices",
          "MySql Connectivity"
         ],
      },
    ],
  },

  {
    id: "Core-Java-Programming-(Beginner-Level)",
    category: "CPC",
    title: "Core Java Programming (Beginner Level)",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["CodeBlock", "Eclipse"],
    build: "Core Java Programming (Beginner Level)",

    syllabus: [
       {
        title: "Java Basics & Setup",
        topics: [
          "Introduction to Java",
          "Installing Java & IDE",
          "Variables & data types",
          "Operators",
          "Input / Output"
         ],
      },
       {
        title: "Control Statements & Functions",
        topics: [
          "Conditional statements (if, switch)",
          "Loops (for, while, do-while)",
          "Methods",
          "Method overloading",
          "Command line arguments"
         ],
      },
        {
        title: "Object-Oriented Programming (OOP)",
        topics: [
          "Classes & Objects",
          "Constructors",
          "Inheritance",
          "Polymorphism",
          "Abstraction",
          "Encapsulation"
         ],
      },
        {
        title: "Collections, Exceptions & Mini Project",
        topics: [
          "Arrays",
          "Collections Framework (List, Set, Map)",
          "Exception handling",
          "Packages",
          "Basic Java coding standards"
         ],
      },
    ],
  },

  {
    id: "Data-Structures-&-Algorithms-(DSA)",
    category: "CPC",
    title: "Data Structures & Algorithms (DSA)",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["CodeBlock", "Idle"],
    build: "Data Structures & Algorithms (DSA)",

    syllabus: [
       {
        title: "Programming & Complexity Basics",
        topics: [
          "Programming revision (C / C++ / Java / Python)",
          "Input / Output handling",
          "Problem-solving approach",
          "Time & Space Complexity",
          "Big-O notation"
         ],
      },
       {
        title: "Arrays & Strings",
        topics: [
          "1D & 2D arrays",
          "Sliding window technique",
          "String manipulation",
          "Searching techniques",
          "Two-pointer approach"
         ],
      },
        {
        title: "Recursion & Backtracking",
        topics: [
          "Recursion basics",
          "Recursive problem solving",
          "Backtracking techniques",
          "Classic problems"
         ],
      },
        {
        title: "Linked List",
        topics: [
          "Singly & doubly linked lists",
          "Insertion & deletion",
          "Circular linked list",
          "Applications"
         ],
      },
              {
        title: "Stack & Queue",
        topics: [
          "Stack implementation",
          "Queue & Deque",
          "Expression evaluation",
          "Real-world applications"
         ],
      },
                    {
        title: "Trees",
        topics: [
          "Binary trees",
          "Tree traversals",
          "Binary Search Tree (BST)",
          "Tree applications"
         ],
      },
                          {
        title: "Graphs",
        topics: [
          "Graph representation",
          "BFS & DFS",
          "Shortest path basics",
          "Graph applications"
         ],
      },
        {
        title: "Sorting & Searching Algorithms",
        topics: [
          "Bubble, Selection, Insertion",
          "Merge & Quick sort",
          "Binary search",
          "Performance comparison"
         ],
      },
              {
        title: "Interview Problems & Practice",
        topics: [
          "Common interview questions",
          "Problem-solving patterns",
          "Competitive coding intro",
          "Mock tests"
         ],
      },
    ],
  },

  {
    id: "CBSE Class 12 – Computer Science (Python + MySQL)",
    category: "CPC",
    title: "CBSE Class 12 – Computer Science (Python + MySQL)",
    duration: "6 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",
    tools:["Python", "MySQL"],
    build: "CBSE Class 12 – Computer Science (Python + MySQL)",

    syllabus: [
       {
        title: "Python Basics & Programming Logic",
        topics: [
          "Introduction to Python",
          "Data types & variables",
          "Operators",
          "Conditional statements",
          "Loops (for, while)",
          "Basic programs"
         ],
      },
       {
        title: "Data Structures & Functions in Python",
        topics: [
          "Strings",
          "Lists",
          "Tuples",
          "Dictionaries",
          "Functions & recursion"
         ],
      },
        {
        title: "File Handling & OOP",
        topics: [
          "File handling (text & binary files)",
          "Classes & objects",
          "Constructors",
          "Basic exception handling"
         ],
      },
        {
        title: "MySQL & Database Connectivity",
        topics: [
          "Database concepts",
          "MySQL installation",
          "DDL & DML commands",
          "Select queries",
          "Python–MySQL connectivity"
         ],
      },
              {
        title: "Practical, Project & Board Revision",
        topics: [
          "CBSE practical programs",
          "Viva questions",
          "Project file preparation",
          "Sample paper solving"
         ],
      }
    ],
  },
  //kidz coding courses will be added here in the future

    {
    id: "Fun Coding with Scratch",
    category: "kidzcoding",
    title: "Fun Coding with Scratch",
    duration: "1 Month",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "To introduce kids to coding through play, helping them develop skills like problem-solving, creativity, and logical thinking by creating interactive stories, games, and animations using Scratch's visual programming blocks.",

    syllabus: [
       {
        title: "Introduction to Coding & Scratch",
        topics: [
          "What is coding? (explained using stories & games)",
          "Introduction to Scratch interface",
          "Sprites & stage",
          "Drag-and-drop coding blocks",
          "Making characters move"
         ],
      },
       {
        title: "Motion, Looks & Sound",
        topics: [
          "Motion blocks (move, turn, glide)",
          "Looks blocks (costumes, size, effects)",
          "Sound blocks (play sounds, record voice)",
          "Creating simple animations"
         ],
      },
        {
        title: "Logic & Game Concepts",
        topics: [
          "Events (when clicked, when key pressed)",
          "Loops (repeat, forever)",
          "Basic conditions (if / else)",
          "Simple game logic"
         ],
      },
        {
        title: "Mini Projects & Presentation",
        topics: [
          "Combining all concepts",
          "Designing own project",
          "Debugging mistakes",
          "Explaining their project"
         ],
      },
    ],
  },

      {
    id: "Coding & App Development Program",
    category: "kidzcoding",
    title: "Coding & App Development Program",
    duration: "3 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "To introduce kids to coding through play, helping them develop skills like problem-solving, creativity, and logical thinking by creating interactive stories, games, and animations using Scratch's visual programming blocks.",

    syllabus: [
       {
        title: "Scratch (Advanced Level)",
        topics: [
          "Review of Scratch basics",
          "Advanced motion & animation",
          "Events & broadcast messages",
          "Loops & nested loops",
          "Conditions (if / if-else)",
          "Variables & operators",
          "Cloning & scoring logic",
          "Debugging projects"
         ],
      },
       {
        title: "Python Programming (Basic)",
        topics: [
          "What is Python & why use it",
          "Python setup & IDE",
          "Variables & data types",
          "Input / output",
          "Conditions (if / else)",
          "Loops (for / while)",
          "Simple functions",
          "Basic problem-solving"
         ],
      },
        {
        title: "MIT App Inventor (Mobile Apps)",
        topics: [
          "Introduction to mobile apps",
          "MIT App Inventor interface",
          "UI components (buttons, labels, images)",
          "Events & logic blocks",
          "Screen navigation",
          "Using sensors (camera, sound)",
          "App testing on mobile",
          "Basic app publishing concept"
         ],
      },
        {
        title: "Mini Projects & Presentation",
        topics: [
          "Combining all concepts",
          "Designing own project",
          "Debugging mistakes",
          "Explaining their project"
         ],
      },
    ],
  },

  {
    id: "Web Design for Kids",
    category: "kidzcoding",
    title: "Web Design for Kids",
    duration: "3 Months",
    icon: "datascience",
    whoCanJoin: "Beginners",

    build: "To introduce kids to coding through play, helping them develop skills like problem-solving, creativity, and logical thinking by creating interactive stories, games, and animations using Scratch's visual programming blocks.",

    syllabus: [
       {
        title: "Introduction to Web & HTML Basics",
        topics: [
          "What is a website?",
          "How the internet works (kid-friendly explanation)",
          "Introduction to HTML",
          "HTML structure (html, head, body)",
          "Headings, paragraphs, text formatting",
          "Images & links",
          "Lists (ordered & unordered)"
         ],
      },
       {
        title: "HTML Pages & Personal Webpage",
        topics: [
          "What is a website?",
          "How the internet works (kid-friendly explanation)",
          "Introduction to HTML",
          "HTML structure (html, head, body)",
          "Headings, paragraphs, text formatting",
          "Images & links",
          "Lists (ordered & unordered)"
         ],
      },
        {
        title: "Styling with CSS (Design & Creativity)",
        topics: [
          "What is CSS?",
          "Colors, fonts, text styles",
          "Backgrounds & borders",
          "Layout basics (box model)",
          "Hover effects & simple animations",
          "Responsive design basics"
         ],
      },
        {
        title: "Mini Portfolio & Basic JavaScript",
        topics: [
        "Introduction to JavaScript (very basic)",
        "Button click actions",
        "Alert messages",
        "Form validation (simple)",
        "Improving website interaction"
         ],
      },
    ],
  },

  //Mobile  Data 
    {
    id: "Android App Development",
    category: "MobileDevlopment",
    title: "Android App Development",
    duration: "3 Months",
    icon: "datascience",
    whoCanJoin: "Students, Job Seekers, Aspiring Mobile App Developers",

    build: "Strong knowledege in Android  Application devlopment..",

    syllabus: [
       {
        title: "Android & Java/Kotlin Basics",
        topics: [
          "Java / Kotlin fundamentals",
          "OOP concepts",
          "Android Studio setup",
          "Gradle basics"
         ],
      },
       {
        title: "UI Design & Layouts",
        topics: [
          "XML layouts",
          "Views & ViewGroups",
          "Material Design",
          "RecyclerView",
          "ConstraintLayout"
         ],
      },
        {
        title: "Activities, Fragments & Navigation",
        topics: [
          "Activity lifecycle",
          "Fragments",
          "Intents",
          "Navigation components"
         ],
      },
        {
        title: "Data Storage & APIs",
        topics: [
        "SharedPreferences",
        "SQLite & Room database",
        "REST API integration",
        "JSON parsing"
         ],
      },
              {
        title: "Advanced Android Concepts",
        topics: [
        "Background services",
        "Notifications",
        "Permissions",
        "Firebase basics (Auth, DB)"
         ],
      },
              {
        title: "App Deployment & Capstone",
        topics: [
        "App testing",
        "Debugging",
        "Play Store guidelines",
        "APK/AAB generation"
         ],
      },
    ],
  },
      {
    id: "Flutter App Development – Detailed Syllabus",
    category: "MobileDevlopment",
    title: "Flutter App Development – Detailed Syllabus",
    duration: "3 Months",
    icon: "datascience",
    whoCanJoin: "Students, Job Seekers, Aspiring Mobile App Developers",

    build: "Strong knowledege in Android  Application devlopment..",

    syllabus: [
       {
        title: "Introduction to Mobile App Development & Flutter",
        topics: [
          "Introduction to Mobile App Development",
"Native vs Hybrid vs Cross-platform apps",
"Overview of Flutter & Dart",
"Flutter architecture",
"Installing Flutter SDK",
"Setting up Android Studio / VS Code",
"Flutter project structure",
"Running first Flutter app"
         ],
      },
       {
        title: "Dart Programming Fundamentals",
        topics: [
          "Dart syntax & keywords",
          "Variables, data types",
          "Operators",
          "Conditional statements",
          "Loops",
          "Functions",
          "Object-Oriented Programming (OOP)",
          "Classes & objects",
          "Constructors",
          "Inheritance",
          "Polymorphism",
          "Abstraction & encapsulation",
          "Lists, Maps & Sets",
          "Null safety"
         ],
      },
        {
        title: "Activities, Fragments & Navigation",
        topics: [
          "Activity lifecycle",
          "Fragments",
          "Intents",
          "Navigation components"
         ],
      },
        {
        title: "Flutter UI Basics & Widgets",
        topics: [
        "Introduction to Widgets",
        "Stateless vs Stateful widgets",
        "Material Design & Cupertino widgets",
        "Scaffold, AppBar, Container",
        "Text, Image, Icon widgets",
        "Buttons (Elevated, Text, Icon)",
        "Row, Column, Stack",
        "Padding, Margin, Alignment",
        "MediaQuery & Responsive UI basics"
         ],
      },
              {
        title: ": State Management & API Integration",
        topics: [
        "Understanding State Management",
"setState()",
"Provider basics",
"Future & Async/Await",
"REST API concepts",
"HTTP package",
"JSON parsing",
"Displaying API data in UI",
"Error handling"
         ],
      },
                    {
        title: "Database & Firebase Integration",
        topics: [
        "Local storage concepts",
"SQLite database",
"CRUD operations",
"Introduction to Firebase",
"Firebase Authentication",
"Firebase Firestore",
"Firebase Storage",
"Push notifications (overview)"
         ],
      },
              {
        title: "App Deployment & Capstone",
        topics: [
        "App testing",
        "Debugging",
        "Play Store guidelines",
        "APK/AAB generation"
         ],
      },
    ],
  },
        {
    id: "React Native App Development – Detailed Syllabus",
    category: "MobileDevlopment",
    title: "React Native App Development – Detailed Syllabus",
    duration: "3 Months",
    icon: "datascience",
    whoCanJoin: "Students, Job Seekers, Aspiring Mobile App Developers",

    build: "Strong knowledege in Android  Application devlopment using REACT NATIVE.",

    syllabus: [
       {
        title: "Introduction to Mobile App Development & React Native",
        topics: [
          "Introduction to Mobile App Development",
"Native vs Hybrid vs Cross-platform apps",
"Overview of React Native",
"How React Native works",
"React Native architecture",
"Environment setup",
"Installing Node.js & npm",
"Setting up Android Studio / Emulator",
"Creating first React Native app"
         ],
      },
       {
        title: "JavaScript & ES6 Fundamentals",
        topics: [
          "JavaScript basics",
"Variables & data types",
"Operators",
"Conditional statements",
"Loops",
"Functions",
"Arrow functions",
"ES6 features",
"let & const",
"Destructuring",
"Spread & Rest operators",
"Template literals",
"Arrays & Objects",
"Classes & OOP basics"
         ],
      },
        {
        title: "React Fundamentals",
        topics: [
          "Introduction to React",
"JSX",
"Components (Functional Components)",
"Props & State",
"Event handling",
"Conditional rendering",
"Lists & keys",
"Component lifecycle (Hooks overview)",
"useState & useEffect hooks"
         ],
      },
        {
        title: "React Native UI Components & Styling",
        topics: [
        "Core React Native components",
"View, Text, Image, ScrollView",
"Button & Touchable components",
"Styling with StyleSheet",
"Flexbox layout system",
"Responsive UI design",
"Platform-specific components",
"Custom reusable components"
         ],
      },
              {
        title: ": State Management & API Integration",
        topics: [
        "Understanding State Management",
"setState()",
"Provider basics",
"Future & Async/Await",
"REST API concepts",
"HTTP package",
"JSON parsing",
"Displaying API data in UI",
"Error handling"
         ],
      },
                    {
        title: "Database & Firebase Integration",
        topics: [
        "Local storage concepts",
"SQLite database",
"CRUD operations",
"Introduction to Firebase",
"Firebase Authentication",
"Firebase Firestore",
"Firebase Storage",
"Push notifications (overview)"
         ],
      },
                    {
        title: "Advanced React Native Concepts",
        topics: [
        "Custom hooks",
"Performance optimization",
"Animations (Animated API)",
"Gesture handling",
"Push notifications (overview)",
"App security basics",
"Debugging & testing"
         ],
      },
              {
        title: "App Deployment & Capstone",
        topics: [
        "App testing",
        "Debugging",
        "Play Store guidelines",
        "APK/AAB generation"
         ],
      },
    ],
  },
];
  